<template>
  <div tabindex="-1" style="position: relative; z-index: 1050; display: block;">
    <div>
      <div
        class="modal show"
        role="dialog"
        tabindex="-1"
        id="VImageCropModal"
        style="display: block;"
      >
        <div  role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">
                <!-- <slot name="modal-title" /> -->
              </h5>
              <button
                type="button"
                class="close m-close"
                aria-label="Close"
                @click="closeCurrentModal()"
              >
                <span  aria-hidden="true">×</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="cropper-container">
                <vue-cropper
                  ref="cropper"
                  :src="imageSrc"
                  :initialAspectRatio="4/3"
                  :zoomable="true"
                  :zoom-on-wheel="true"
                  :img-style="{ width: '100%', height: '400px' }"
                  :minCropBoxWidth="350"
                  :minCropBoxHeight="250"
                  :move="true"
                  :draggable="true"
                  :dragMode="'move'"
                />
              </div>
              
            </div>
            <div class="modal-footer">
                <button
                type="button"
                class="btn btn-primary btn-lg submit submit_custom"
                @click="cropImage"
              >
                Crop & Upload
              </button>
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueCropper from "vue-cropperjs";
import 'cropperjs/dist/cropper.css';

export default {
  name: "ImageCropModal",

  components: {
    VueCropper
  },
  props: {
    imageSrc: String,
    imageName: String,
    closeCurrentModal: Function,
    uploadFiles: Function,
  },
  data: () => ({}),

  computed: {
    // VueCropper
  },

  methods: {
    onCropperReady() {
      const cropper = this.$refs.cropper;
      console.log("cropper")
// Check if the cropper instance exists
if (cropper && cropper.cropper) {
  // Set the minimum crop box size directly on options
  cropper.cropper.options.minCropBoxWidth = 800;
  cropper.cropper.options.minCropBoxHeight = 600;


}
    },
    cropImage() {
      const cropper = this.$refs.cropper;
      const croppedCanvas = cropper.getCroppedCanvas();

      croppedCanvas.toBlob((blob) => {
          const croppedFile = new File([blob], this.imageName, { type: 'image/png' });
          console.log("croppedFile",croppedFile);
          debugger
          this.uploadFiles([croppedFile])
        }, 'image/png');

    },
  },
  mounted() {
    console.log("imageSrc",this.imageSrc)
  }
};
</script>
<style scoped>
.cropper-container {
  height: 400px; 
}
